import { IBaseEntity } from './base';
import { ID } from './id'

export enum BatchActivityType {
    RemoveIssue = 'RemoveIssue',
    RemoveProject = 'RemoveProject',
    RemoveMovedIssue = 'RemoveMovedIssue',
    IssueNotInteresting = 'IssueNotInteresting',
    IssueBecomeInteresting = 'IssueBecomeInteresting',
    AppointmentBecomeInteresting = 'AppointmentBecomeInteresting',
    AppointmentNotInteresting = 'AppointmentNotInteresting',
    AppointmentsNotInteresting = 'AppointmentsNotInteresting',
    AppointmentResync = 'AppointmentResync'
}

export interface IBatchActivity extends IBaseEntity {
    type: BatchActivityType;
    param?: string;
    projectId?:ID;
}
